import { render, staticRenderFns } from "./DashboardCoverage.vue?vue&type=template&id=dee105e4&"
import script from "./DashboardCoverage.vue?vue&type=script&lang=js&"
export * from "./DashboardCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports